import axiosClient from "@/utils/axios-client";
import { toSnakeKeyObject } from "@/utils/case";
import { BuyerBusinessLicenseRequestBody } from "@/shared/api/business-license/types";
import { businessLicenseUrl } from "@/shared/api/business-license/url";

export const businessLicenseMutationApi = {
  // 바이어 사업자등록증 등록/교체 — 최초 등록과 교체를 POST 하나로 처리한다.
  updateBuyerBusinessLicense: async (
    buyerId: number,
    body: BuyerBusinessLicenseRequestBody
  ) =>
    await axiosClient.post(
      businessLicenseUrl.root(buyerId),
      toSnakeKeyObject(body)
    ),
};
